import { PackagedTypeEnum } from '../../../types/properties/PackagedTypeEnum';
import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import { SecurityRuleTypeEnum } from '../../../types/properties/PropertySecurity';
import { PERMISSION_KEYS, MobilePermissionEnum } from 'constants-permissions';

const OpenpathDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Openpath,
  hasCustomUI: true,
  friendlyName: 'Openpath Access Control',
  description: `Defines the properties required for an Openpath integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    regionalURL: {
      friendlyName: 'Openpath API URL',
      type: 'Option',
      packagedType: PackagedTypeEnum.Dropdown,
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'In',
          value: [
            {
              _id: '0',
              _order: 0,
              name: 'https://api.openpath.com/',
              value: 'https://api.openpath.com/',
            },
            {
              _id: '1',
              _order: 1,
              name: 'https://api.eu.openpath.com/',
              value: 'https://api.eu.openpath.com/',
            },
          ],
        },
      ],
    },
    adminUserEmail: {
      friendlyName: 'Openpath Admin user email',
      type: 'Email',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value:
              PERMISSION_KEYS.PERMISSION_ACCESS_CONTROL_MOBILE_ACCESS_DISABLE,
          },
        ],
      },
    },
    adminUserPassword: {
      friendlyName: 'Openpath Admin user password',
      type: 'Password',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    organizationId: {
      friendlyName: 'Openpath organization id',
      type: 'Number',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    authToken: {
      hidden: true,
      forDisplay: false,
      friendlyName: 'Auth Token',
      description: 'Auth Token field to control access of the field',
      type: 'String',
      validators: [],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
  },
  mobilePermissions: [
    MobilePermissionEnum.Location,
    MobilePermissionEnum.AlwaysLocation,
    MobilePermissionEnum.Bluetooth,
  ],
  // Google requires us to use specific language requesting background location access before we load the system prompts
  mobilePermissionsRequest:
    'To unlock doors, Workplace Access requires these device settings to be enabled, including accessing your location when the application is not in use.',
};

/**
 * @deprecated Use `OpenpathDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { OpenpathDefinition } from 'application-types';`
 */
export default OpenpathDefinition;
